function t(r, i) {
  return r.priority || (r.priority = 100), i.priority || (i.priority = 100), r.priority > i.priority ? 1 : r.priority < i.priority ? -1 : 0;
}
export {
  t as NavigationItemComparer
};
